import { Component, ElementRef } from "@angular/core";
import { HelpDeskModel } from "@app/models/merchant-settlement-model/merchant-settlement-model";
import { TransactionHistoryService } from "@app/services/transactionHistory/transactionHistory.service";
import { ActivatedRoute, Router } from "@angular/router";
import { ValueType } from "@app/common/valuetype";
import { ApiResponse } from "@app/models/OTPResult";
import { ToastrService } from "ngx-toastr";
import { AppSettings } from "@app/common/app-setting";

@Component({
    selector: 'issueDetails',
    templateUrl: './issueDetails.component.html',
})
export class IssueDetailsComponent {
    issuerDetails = new HelpDeskModel();
    saveIssuerDetails = new HelpDeskModel();
    issuerGridDetails = new Array<HelpDeskModel>();
    issuerStatus = new Array<ValueType>();
    issuerFilter = new HelpDeskModel();
    apiModel = new ApiResponse();
    errorMessageComment: string;
    errorMessageStatus: string;
    pageNumber: number = 0;
    itemPerPage: number = 4;
    tempCount: number;
    //ticketManagementModel = new TicketManagementModel();
    fidx = 1;
    fileExt: string;
    UploadedImageName: any;
    invalidFileTypeErrorMessage: string = '';
    ticketId: number;
    serverUrl = null;
    showIssueStatus: boolean = AppSettings.showIssueStatusDropdown;
    EntityTypeId: string = "0";

    ngOnInit() {
        this.EntityTypeId = localStorage.getItem('EntityType');
        if (this.EntityTypeId == '115')
            this.showIssueStatus = true;
        this.route.params.subscribe(params => {
            if (params['TicketId']) {
                this.issuerFilter.TicketId = params['TicketId'];
            }
            if (params['IssueType']) {
                this.issuerFilter.Status = params['IssueType'];
            }
        });
        this.getIssuerDetailData();
        this.getIssuerGridDetailData();
        this.getIssuerStatus();

    }

    constructor(private transactionhistoryService: TransactionHistoryService, private route: ActivatedRoute,
        private toastr: ToastrService, private router: Router,
        private el: ElementRef) { }

    getIssuerDetailData() {
        this.transactionhistoryService.getIssuerDetailData(this.issuerFilter).subscribe(data => {
            this.issuerDetails = JSON.parse(JSON.stringify(data));
            //this serverURL path is defined here because at declaration level the outlet id is undefined 
            this.serverUrl = `${AppSettings.API_ENDPOINT}` + '/Files/Id' + this.issuerDetails.OutletId + '/';
            this.saveIssuerDetails.MerchantName = this.issuerDetails.MerchantName;
            this.saveIssuerDetails.TicketId = this.issuerFilter.TicketId;
        });
    }

    getIssuerGridDetailData() {
        this.transactionhistoryService.getIssuerGridDetailData(this.issuerFilter).subscribe(data => {
            this.issuerGridDetails = JSON.parse(JSON.stringify(data));
            console.log(this.serverUrl);
            for (let data of this.issuerGridDetails)
                if (data.FileName == "" || data.FileName == undefined) data.FileName = null;
            this.tempCount = this.issuerGridDetails.length;
        });
    }

    getIssuerStatus() {
        this.transactionhistoryService.getIssuerStatus().subscribe(data => {
            this.issuerStatus = JSON.parse(JSON.stringify(data));
        });
    }

    saveTicketMgmtData() {
        if (this.saveIssuerDetails.Comments != null && this.saveIssuerDetails.Comments != undefined && this.saveIssuerDetails.Comments != ''
        &&this.saveIssuerDetails.Status != 0 &&this.saveIssuerDetails.Status != undefined) {

            this.transactionhistoryService.saveTicketMgmtData(this.saveIssuerDetails).subscribe(data => {
                this.apiModel = JSON.parse(JSON.stringify(data));
                this.getIssuerGridDetailData();
                this.errorMessageComment = '';
                this.errorMessageStatus = '';
                this.saveIssuerDetails.Comments = null;
                this.saveIssuerDetails.FileName = '';
                this.saveIssuerDetails.Status = 0;
                if (this.apiModel != undefined && this.apiModel.Status != false) {
                    this.toastr.success(this.apiModel.SuccessMessage, 'Issue Details');
                }
                else {
                    this.toastr.error(this.apiModel.ErrorMessage, 'Issue Details');
                }
            });
        }
        else if (this.saveIssuerDetails.Comments == null || this.saveIssuerDetails.Comments ==undefined ||this.saveIssuerDetails.Comments =='') {
            this.errorMessageComment = 'Field required.';
            this.errorMessageStatus = '';
        }
        else if (this.saveIssuerDetails.Status == 0 || this.saveIssuerDetails.Status ==undefined) {
            this.errorMessageStatus = 'Field required.';
            this.errorMessageComment = '';
        }
    }

    cancel() {
        if (this.EntityTypeId == '115')
        {
            this.router.navigate(['/secure/admin/HelpDesk/'+ this.issuerDetails.MerchantCode + '/' + this.issuerDetails.OutletId + '/' + this.issuerDetails.TerminalCode]);
        }
        else if (this.EntityTypeId != '115'){
        this.router.navigate(['/app/merchant/HelpDesk']);
    }
    }

    pageControl(event: number, sortName: string) {
        this.pageNumber = event;
        this.getIssuerGridDetailData();
    }

    upload($event, uploaderIndex: number, value: number) {
        let imageName = '#photo' + uploaderIndex;
        let inputEl: HTMLInputElement = this.el.nativeElement.querySelector(imageName);
        let fileCount: number = inputEl.files.length;
        let formData = new FormData();

        if (this.validateFileType(inputEl.files.item(0).name)) {
            if (fileCount > 0) {
                formData.append('photo', inputEl.files.item(0));
                formData.append('Check', inputEl.files.item(1));
                this.transactionhistoryService.fileUpload(formData, this.issuerDetails.OutletId).subscribe(data => {
                    this.saveIssuerDetails.FileName = data[0].fileName;
                    this.el.nativeElement.querySelector(imageName).value = "";
                },
                    error => {
                        this.el.nativeElement.querySelector(imageName).value = "";
                    }
                );
            }
        }
    }

    validateFileType(fileName: string) {
        var validExts = new Array(".bmp", ".xls", ".pdf", ".png", ".jpg", ".svg", ".doc");
        this.fileExt = fileName.substring(fileName.lastIndexOf('.'));
        if (validExts.indexOf(this.fileExt) < 0) {
            this.invalidFileTypeErrorMessage = 'Invalid file type';
            this.UploadedImageName = "";
            return false;
        }
        else {
            this.invalidFileTypeErrorMessage = '';
            return true;
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/components/common/help-desk/issueDetails.component.ts